module.exports = __webpack_public_path__ + "img/soil-moisture-teros-10.4a0e2dc9.svg";